import gql from 'graphql-tag';

export const QUERY_PROMOTION_PLAN = gql`
  query CMS_PromotionPlan($id: ID) {
    referralCommissionPlan(id: $id) {
      bookingDestinationCountryId
      bookingDestinationCountry {
        name
        slug
      }
      bookingDestinationCityIds
      bookingDestinationCities {
        name
        id
      }
      type
      status
      validDateFrom
      validDateTo
      default
      externalName
      id
      name
      createdAt
      updatedAt
      countryCode
      countryHasDefault
      currency
      paymentPreference
      updatedUser {
        firstName
        lastName
      }
      country {
        name
      }
      tiers {
        shortTermCalculationValue
        longTermCalculationValue
        bookingCountTo
        bookingCountFrom
        bookingCompletedDateTo
        bookingCompletedDateFrom
        bookingSubmittedDateFrom
        bookingSubmittedDateTo
        name
        calculationRules {
          leaseType
          tenancyLengthFrom
          tenancyLengthTo
          calculationValue
          calculationType
        }
      }
    }
  }
`;

export const QUERY_PROMOTION_PLANS = gql`
  query CMS_PromotionPlans(
    $searchName: NonEmptyString
    $countryCode: NonEmptyString
    $pageSize: Int!
    $pageNumber: Int!
    $sortBy: [ReferralCommissionPlanSortBy!]
    $status: ReferralCommissionPlanStatus
  ) {
    referralCommissionPlans(
      searchName: $searchName
      countryCode: $countryCode
      pageSize: $pageSize
      pageNumber: $pageNumber
      sortBy: $sortBy
      type: PROMOTIONAL
      status: $status
    ) {
      totalCount
      pageInfo {
        numPages
        hasNextPage
        hasPreviousPage
      }
      edges {
        node {
          status
          validDateFrom
          validDateTo
          id
          paymentPreference
          name
          currency
          country {
            name
          }
          partners {
            name
          }
          partnerReferralCommissionPlans {
            id
          }
          tiers {
            shortTermCalculationValue
            longTermCalculationValue
          }
        }
      }
    }
  }
`;

export const QUERY_COUNTRY = gql`
  query country($pageSize: Int, $pageNumber: Int) {
    countries(pageNumber: $pageNumber, pageSize: $pageSize) {
      edges {
        node {
          name
          countryCode
          currencyCode
        }
      }
    }
  }
`;

export const QUERY_COUNTRY_CITYS = gql`
  query selectedCountryCities($slug: String, $cityPageNumber: Int, $searchCitySlug: [String]) {
    country(slug: $slug) {
      id
      name
      slug
      cities(pageSize: 20, pageNumber: $cityPageNumber, slugs: $searchCitySlug) {
        totalCount
        pageInfo {
          hasNextPage
          hasPreviousPage
          numPages
        }
        edges {
          node {
            id
            name
            slug
          }
        }
      }
    }
  }
`;

export const QUERY_CHECK_DEFAULT_PLAN = gql`
  query defaultPlan($countryCode: NonEmptyString) {
    getCountryDefaultReferralCommissionPlan(countryCode: $countryCode) {
      id
      name
      countryCode
      currency
    }
  }
`;

export const QUERY_CHECK_NAME = gql`
  query checkname($name: NonEmptyString, $type: ReferralCommissionPlanType) {
    checkReferralCommissionPlanNameExists(name: $name, type: $type) {
      exists
    }
  }
`;

export const CREATE_PLAN = gql`
  mutation createPlan($input: CreateReferralCommissionPromotionPlanInput) {
    createReferralCommissionPromotionPlan(input: $input) {
      name
      id
      status
      validDateTo
      validDateFrom
      tiers {
        shortTermCalculationValue
        longTermCalculationValue
        bookingCompletedDateTo
        bookingCompletedDateFrom
        bookingSubmittedDateFrom
        bookingSubmittedDateTo
      }
    }
  }
`;

export const UPDATE_PLAN = gql`
  mutation updatePlan($input: UpdateReferralCommissionPromotionPlanInput) {
    updateReferralCommissionPromotionPlan(input: $input) {
      name
      id
      status
      validDateTo
      validDateFrom
      tiers {
        shortTermCalculationValue
        longTermCalculationValue
        bookingCompletedDateTo
        bookingCompletedDateFrom
        bookingSubmittedDateFrom
        bookingSubmittedDateTo
      }
    }
  }
`;

export const DELETE_PLAN = gql`
  mutation deletePlan($id: String!) {
    deleteReferralCommissionPlan(id: $id) {
      id
      externalName
      name
    }
  }
`;
